import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Dialog,
    FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  DialogActions, DialogContent,  DialogContentText, DialogTitle, CardContent,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useStyles } from "../../../theme/appStyles";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import {
  useGetCategoryQuery,
  useGetPrinterQuery,
  useGetProductBrandQuery,
  useGetProductQuery,
  useGetVariantQuery,
  useGetProductTagQuery,
  useDeleteVariantMutation,
  useGetModifierGroupQuery,
  useGetModifierQuery,
  useGetProductCategoryQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IPrinter,
  IProduct,
  IProductBrand,
  IProductTag,
  IProductPopUP,
  IVariantPopUP,
  IModifierGroupPopUp,
  IModifierPopUp,
  ModifierInfo
} from "../../../Api/Interface/api.interface";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import Barcode from "react-barcode";
import placeholderImage from '../../../Images/fav.png';
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import EditVariantPopUp from "../Components/EditVariantPopUp";
import CreateVariantPopUp from "../Components/CreateVariantPopUp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import { Dayjs } from "dayjs";
import Switch, { SwitchProps } from "@mui/material/Switch";
import axios from "axios";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";

interface ModifierGroupSelection {
  id?: number;
  modifierGroupId: number;
  required: boolean;
  minimum: number;
  maximum: number;
  order: number | null;
  modifiers?:ModifierInfo[];
}


const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [searchQuery, setSearchQuery] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedModifierGroupIds, setSelectedModifierGroupIds] = useState<number[]>([]);

    const [selectedProduct, setSelectedProduct] = useState<IVariantPopUP | null>(
      null
    );
     const getFormattedDate = (createDate: Dayjs | null): string => {
        return createDate ? createDate.format("YYYY-MM-DD") : "";
      };

     const [selectedProductBrandId, setSelectedProductBrandId] =
        useState<string>("");
      const [selectedProductCategoryId, setSelectedProductCategoryId] =
        useState<string>("");
      const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
        []
      );
       const [selectedProductViewOnline, setSelectedProductViewOnline] =
          useState<string>("");
        const [startDate, setStartDate] = useState<Dayjs | null>(null);
          const [endDate, setEndDate] = useState<Dayjs | null>(null);
          const startDateAsDate = startDate?.toDate() || null;
          const endDateAsDate = endDate?.toDate() || null;
            const [createDate, setCreateDate] = useState<Dayjs | null>(null);
           const [currentSearchQuery, setCurrentSearchQuery] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [openCreateVariantDialog, setOpenCreateVariantDialog] = useState(false);
    const { showErrorMessage, showMessage } = useNotifier();
    const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
    const [productToDelete, setProductToDelete] = useState<IVariantPopUP | null>(
      null
    );
  const [selectedCard, setSelectedCard] = useState<string | null>("Modifier Group");

  const API_URL = process.env.REACT_APP_API_URL;
const [showModifierGroupPopup, setShowModifierGroupPopup] = useState(false);
const [selectedModifierGroups, setSelectedModifierGroups] = useState<ModifierGroupSelection[]>([]);
const [selectedModifierGroupId, setSelectedModifierGroupId] = useState<number | null>(null);
const [modifierGroupDetails, setModifierGroupDetails] = useState<IModifierGroupPopUp | null>(null);

const [linkedProducts, setLinkedProducts] = useState<IProduct[]>([]);
const [selectedProducts, setSelectedProducts] = useState<IProduct[]>([]);
const [selectedLinkedProductId, setSelectedLinkProductId] = useState<number | null>(null);
const [showLinkedProductPopup, setShowLinkedProductPopup] = useState(false);
const [productSearchTerm, setProductSearchTerm] = useState("");
const [productSearchResults, setProductSearchResults] = useState([]);


  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);

  

  const { data, isLoading, isError, refetch: refetchProduct } = useGetProductQuery({
    searchText: "",
    id: String(ProductId),
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });
  const { data: allProductsData } = useGetProductQuery({
  searchText: "",
  id: null,
  productBrandId: null,
  productCategoryId: null,
  productTagIds: null,
  productViewOnline: null,
  createdDateStart: null,
  createdDateEnd: null,
  createdDate: null,
});
  

  const { data: productBrandData, isLoading: productBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const { data: tagData, isLoading: tagLoading } = useGetProductTagQuery({
    searchText: "",
    isActive: true,
  });

  const { data: printerData, isLoading: printerLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
        null
      );
      const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
        number | null
      >(null);
    
      const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
        number | null
      >(null);
    
      const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
        useState<number | null>(null);
    
      const { data: subCategoryData, refetch: refetchSubCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
        });
    
      const { data: subCategory2Data, refetch: refetchS2bCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedSubCategoryId
            ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
            : [],
        });
    
      const { data: subCategory3Data, refetch: refetchS3bCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedSubCategoryId
            ? [
                Number(selectedCategoryId),
                Number(selectedSubCategoryId),
                Number(selectedSubToSubCategoryId),
              ]
            : [],
        });
    
   
      const subCategoryList = useMemo(() => {
        return subCategoryData?.data as ICategory[];
      }, [subCategoryData?.data]);
    
      const subToSubCategoryList = useMemo(() => {
        return subCategory2Data?.data as ICategory[];
      }, [subCategory2Data?.data]);
    
      const subToSubToSubCategoryList = useMemo(() => {
        return subCategory3Data?.data as ICategory[];
      }, [subCategory3Data?.data]);
    
      const productCategoryId = selectedSubToSubToSubCategoryId
        ? Number(selectedSubToSubToSubCategoryId)
        : selectedSubToSubCategoryId
        ? Number(selectedSubToSubCategoryId)
        : selectedSubCategoryId
        ? Number(selectedSubCategoryId)
        : selectedCategoryId
        ? Number(selectedCategoryId)
        : String("");

  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IProduct;
    }
    return null;
  }, [data]);
  

React.useEffect(() => {
  if (product?.modifierGroupId) {
    if (typeof product.modifierGroupId === "string") {
      try {
        const parsed: ModifierGroupSelection[] = JSON.parse(product.modifierGroupId);
        // Normalize required field to always be boolean
        const normalized = parsed.map(item => ({
          modifierGroupId: item.modifierGroupId,
          required: item.required ?? false,
          order: item.order ?? null, 
          maximum: item.maximum ?? null,
          minimum: item.minimum ?? null,
             modifiers: Array.isArray(item.modifiers) ? item.modifiers : [], 
        }));
        setSelectedModifierGroups(normalized);
      } catch (err) {
        console.error("Failed to parse modifierGroupId", err);
        setSelectedModifierGroups([]);
      }
    } else if (Array.isArray(product.modifierGroupId)) {
      // Normalize required field to always be boolean
      const normalized = product.modifierGroupId.map((item: any) => ({
        modifierGroupId: item.modifierGroupId,
        required: item.required ?? false,
        order: item.order ?? null, 
        maximum: item.maximum ?? null,
        minimum: item.minimum ?? null,
modifiers: Array.isArray(item.modifiers) ? item.modifiers : [], 
      }));
      setSelectedModifierGroups(normalized);
    } else {
      setSelectedModifierGroups([]);
    }
  } else {
    setSelectedModifierGroups([]);
  }
}, [product]);

React.useEffect(() => {
  if (product?.linkedProductId) {
    try {
      const ids = JSON.parse(product.linkedProductId); // parse "[8,9]" → [8, 9]
      setLinkedProducts(Array.isArray(ids) ? ids : []);
    } catch {
      setLinkedProducts([]);
    }
  } else {
    setLinkedProducts([]);
  }

}, [product]);






 const { data: variantData, isLoading: variantLoading } =
    useGetVariantQuery({  searchText: "",
    id: null,
    productId: String(ProductId),
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const { data: modifierGroupData, isLoading: modifierLoading } = useGetModifierGroupQuery({
    productBrandId: selectedProductBrandId,
    productCategoryId: String(productCategoryId),
    productTagIds: selectedProductTagIds,
    modifierViewOnline: selectedProductViewOnline,
    createdDateStart: startDateAsDate as Date,
    createdDateEnd: endDateAsDate as Date,
    searchText: currentSearchQuery,
    createdDate: getFormattedDate(createDate),
    id: null,
  });

    const { data: modifierData } = useGetModifierQuery({
         productBrandId:  null,
        productCategoryId:  null,
        productTagIds: null,
        modifierViewOnline:null,
        createdDateEnd:  null,
        createdDateStart:null,
        searchText: null,
        createdDate: null,
        id:  "",
        });


    const coursings: IVariantPopUP[] = Array.isArray(variantData?.data)
      ? (variantData?.data as IVariantPopUP[])
      : [];

    

  const modifierGroupList: IModifierGroupPopUp[] = Array.isArray(modifierGroupData?.data)
  ? (modifierGroupData?.data as IModifierGroupPopUp[])
          : [];

  const products: IProduct[] = Array.isArray(allProductsData?.data)
  ? (allProductsData?.data as IProduct[])
          : []; 

  const modifierList = useMemo(() => {
  return modifierData?.data as IModifierPopUp[];
    }, [modifierData?.data]);

const filteredModifierGroups = modifierGroupList.filter(
  (group) =>
    !selectedModifierGroups.some(
      (selected) => Number(selected.modifierGroupId) === Number(group.id)
    )
);

const filteredProducts = products.filter(
  (group) => !linkedProducts.some(
    (selectedId) => Number(selectedId) === Number(group.id) 
  )
);


  const productBrandList = useMemo(() => {
    return productBrandData?.data as IProductBrand[];
  }, [productBrandData?.data]);

  const productTagList = useMemo(() => {
    return tagData?.data as IProductTag[];
  }, [tagData?.data]);

  const printerList = useMemo(() => {
    return printerData?.data as IPrinter[];
  }, [printerData?.data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, brand.productBrandName);
    });
    return map;
  }, [productBrandList]);

  const productTagMap = useMemo(() => {
    const map = new Map();
    productTagList?.forEach((tag) => {
      map.set(tag.id, tag.tagName);
    });
    return map;
  }, [productTagList]);

  const ProductPrinterMap = useMemo(() => {
    const map = new Map();
    printerList?.forEach((printer) => {
      map.set(printer.id, printer.printerName);
    });
    return map;
  }, [printerList]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryList]);


 const savedGroups = Array.isArray(product?.modifierGroupId)
  ? product?.modifierGroupId
  : JSON.parse(product?.modifierGroupId || "[]");

  const cardsData = [
  {
    title: "Active",
    value: product?.productCanSell,
  },
  {
    title: "Variant",
    value: product?.hasVariants,
  },
  {
    title: "Modifier Group",
    value: product?.modifierGroupId,  // Adjust if needed differently
  },
  {
    title: "POS Display",
    value: product?.productViewOnline,
  },
  {
    title: "Looping",
    value: product?.productDetailsIsLooping,
  },
];




 const handleCreateOpenDialog = () => {
    setOpenCreateVariantDialog(true);
  };

  const handleCreateCloseDialog = () => {
    setOpenCreateVariantDialog(false);
  };

  const handleOpenDialog = (product: IVariantPopUP) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (product: IVariantPopUP) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

//   const handleAddModifierGroup = (group: IModifierGroupPopUp) => {
//   const alreadyExists = selectedModifierGroups.some((g) => g.id === group.id);
//   if (!alreadyExists) {
//     setSelectedModifierGroups([...selectedModifierGroups, group]);
//   }
//   setShowModifierGroupPopup(false);
// };


   const [deleteVariant] = useDeleteVariantMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteVariant(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProduct(false);
      } else {
        showErrorMessage("Failed to delete the variant");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the variant");
    }
  };


//  const handleCheckboxToggle = (id: number) => {
//   setSelectedModifierGroups(prev => {
//     const exists = prev.find(item => item.modifierGroupId === id);
    
//     if (exists) {
//       // Remove the modifier group if already selected
//       return prev.filter(item => item.modifierGroupId !== id);
//     } else {
//       // Add new modifier group WITHOUT assigning order by default
//       return [
//         ...prev,
//         {
//           modifierGroupId: id,
//           required: false,
//           order: null,  // or simply omit this line if your type allows
//           maximum: null,
//           minimum: null,
//         },
//       ];
//     }
//   });
// };



// const handleSaveModifierGroups = async () => {
//   const payload = {
//     productId: String(ProductId), // or get from props/state
//     modifierGroupId: JSON.stringify(selectedModifierGroups), // Must be JSON string
//   };

//   try {
//     const response = await axios.put(`${API_URL}/update-modifierGroup`,
//       payload,
//       {
//          headers: {
//           'Content-Type': 'application/json',
//            Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // Include token from localStorage
//            },
//       }
//     );

//     if (response.data.status) {
//       // console.log('Update successful:', response.data.message);
//       showMessage('Modifier groups added!');
//       refetchProduct();
//       setShowModifierGroupPopup(false); // Close dialog
//     } else {
//       showErrorMessage(response.data.message || 'Update failed');
//     }
//   } catch (error) {
//     console.error('Error updating modifier group:', error);
//     showErrorMessage('Something went wrong');
//   }
// };


const handleSaveModifierGroups = async () => {
  if (!modifierGroupDetails) return;



  const groupId = Number(modifierGroupDetails.id);

  // Check if this group already exists in the selectedModifierGroups array
  const exists = selectedModifierGroups.some(g => g.modifierGroupId === groupId);

  // Prepare the new/updated group data object
  const newGroup = {
    modifierGroupId: groupId,
    required: modifierGroupDetails.required ?? false,
    order: modifierGroupDetails.order ?? null,
    minimum: modifierGroupDetails.minimum ?? 0,
    maximum: modifierGroupDetails.maximum ?? 0,
    modifiers: (modifierGroupDetails.modifiers || []).map((mod: any) => ({
      modifier_id: mod.modifier_id,
      overwrite: mod.overwrite ?? false,
      overwrite_price: mod.overwrite_price ?? null,
    })),
  };

  const isDuplicateOrder = selectedModifierGroups.some(g =>
    g.modifierGroupId !== groupId && g.order === newGroup.order
  );

  if (isDuplicateOrder) {
    showErrorMessage(`Order number ${newGroup.order} is already used. Please choose a different one.`);
    return;
  }

  // Create updated array with new or replaced group
  let updatedGroups = [];
  if (exists) {
    updatedGroups = selectedModifierGroups.map(g =>
      g.modifierGroupId === groupId ? newGroup : g
    );
  } else {
    updatedGroups = [...selectedModifierGroups, newGroup];
  }

  // Update local state immediately for responsiveness
  setSelectedModifierGroups(updatedGroups);

  // Prepare payload for API
  const payload = {
    productId: String(ProductId), // Make sure ProductId is in your component scope
    modifierGroupId: JSON.stringify(updatedGroups),
  };

  try {
    const response = await axios.put(`${API_URL}/update-modifierGroup`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
    });

    if (response.data.status) {
      showMessage('Modifier groups saved successfully!');
      refetchProduct();  // Optional: refetch your product data if needed
      setShowModifierGroupPopup(false);
      setSelectedModifierGroupId(null);
      setModifierGroupDetails(null);
    } else {
      showErrorMessage(response.data.message || 'Failed to save modifier groups.');
    }
  } catch (error) {
    console.error('Error saving modifier groups:', error);
    showErrorMessage('Something went wrong. Please try again.');
  }
};

const handleSaveLinkedProducts = async () => {
  if (!linkedProducts || linkedProducts.length === 0) return;

  // Get only IDs of newly selected products
  const newLinkedIds = linkedProducts.map(p => p.id);

  // Get previously saved linked product IDs from `product.linkedProductId`
  let previousIds: number[] = [];
  if (product?.linkedProductId) {
    try {
      const parsed = JSON.parse(product.linkedProductId); // e.g., [1,2]
      previousIds = Array.isArray(parsed) ? parsed : [];
    } catch {
      previousIds = [];
    }
  }

  // Merge previous and new IDs
  const allIds = Array.from(new Set([...previousIds, ...newLinkedIds]));

  try {
    const response = await axios.put(`${API_URL}/update-linkedProducts`, {
      productId: String(ProductId),
      linkedProductIds: JSON.stringify(allIds), // send full array
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
    });

    if (response.data.status) {
      showMessage('Linked products saved successfully!');
      refetchProduct();
      setShowLinkedProductPopup(false);
    } else {
      showErrorMessage(response.data.message || 'Failed to save linked products.');
    }
  } catch (error) {
    console.error('Error saving linked products:', error);
    showErrorMessage('Something went wrong. Please try again.');
  }
};





const handleEditModifierGroup = (group: ModifierGroupSelection) => {
  setSelectedModifierGroupId(group.modifierGroupId);
  setModifierGroupDetails({
     id: String(group.modifierGroupId), 
    required: group.required,
    order: group.order ?? undefined,
    minimum: group.minimum,
    maximum: group.maximum,
    modifiers: group.modifiers ?? [],
  });
  setShowModifierGroupPopup(true);
};

const handleDeleteModifierGroup = async (modifierGroupId: number) => {
  const confirmed = window.confirm("Are you sure you want to delete this modifier group?");
  if (!confirmed) return; // Exit if user cancels

  // Remove locally
  const updatedGroups = selectedModifierGroups.filter(g => g.modifierGroupId !== modifierGroupId);


  // Update backend (optional)
  try {
    await axios.put(`${API_URL}/update-modifierGroup`, {
      productId: String(ProductId),
      modifierGroupId: JSON.stringify(updatedGroups),
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`
      }
    });
    showMessage('Modifier Group deleted successfully');
    setSelectedModifierGroups(updatedGroups);
  } catch (error) {
    console.error(error);
    showErrorMessage('Failed to delete Modifier Group');
  }
};

const handleDeleteLinkedProduct = async (linkedProductId: any) => {
  const confirmed = window.confirm("Are you sure you want to delete this linked product?");
  if (!confirmed) return; // Exit if user cancels

  // Remove locally
  const updatedGroups = linkedProducts.filter((id) => id !== linkedProductId);

  try {
    await axios.put(`${API_URL}/update-linkedProducts`, {
      productId: String(ProductId),
      linkedProductIds: JSON.stringify(updatedGroups),
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`
      }
    });
    showMessage('Linked product deleted successfully');
    setLinkedProducts(updatedGroups);
  } catch (error) {
    console.error(error);
    showErrorMessage('Failed to delete Linked product');
  }
};


  if (
    isLoading ||
    productBrandLoading ||
    tagLoading ||
    printerLoading ||
    categoryLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching product details data. Please try again later.
      </Typography>
    );
  }

 



  return (
    <Grid container spacing={3}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.stepperCard}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={9}
              md={9}
              sm={9}
              xs={9}
              pt={2}
              alignContent={"center"}
            >
              <Typography variant="h2">{product?.productName}</Typography>
            </Grid>
            <Grid
              item
              lg={3}
              md={3}
              sm={3}
              xs={3}
              pt={2}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    variant="outlined"
                    endIcon={<ArrowForwardIosIcon />}
                    className={classes.addButton}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Grid container spacing={2}>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      pb={5}
                      alignContent={"center"}
                    >
                     <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={1} pb={5}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          {product?.productName}
                        </span>{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Name :
                        </span>{" "}
                        {product?.productName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Category :
                        </span>{" "}
                        {categoryMap.get(product?.productCategoryId) || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Brand :
                        </span>{" "}
                        {productBrandMap.get(product?.productBrandId) || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Tag :
                        </span>{" "}
                        {(product?.productTagIds || [])
                          .map((tagId) => productTagMap.get(tagId) || "")
                          .join(", ")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Conversion unit :
                        </span>{" "}
                        {product?.productConversionUnit
                          ?.map((unit) => {
                            const unitLabel = Object.keys(SizeOfLevelType).find(
                              (key) =>
                                SizeOfLevelType[
                                  key as keyof typeof SizeOfLevelType
                                ] === unit
                            );
                            return unitLabel;
                          })
                          .join(", ") || " "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Printers :
                        </span>{" "}
                        {(product?.productPrinterIds || [])
                          .map((tagId) => ProductPrinterMap.get(tagId) || "")
                          .join(", ")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Short Description :
                        </span>{" "}
                        {product?.productShortDescription}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>


           <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard} sx={{ minHeight: "250px" }}>
              <Grid container spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Long Description :
                        </span>{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        {product?.productLongDescription}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      pb={5}
                      alignContent={"center"}
                    >
                      <Box className={classes.productBox}>
                        <img
                          // src={product?.productImg}
                          src={product?.productImg ?`${LARAVEL_API_URL}/${String(product?.productImg)}` : placeholderImage}
                          alt="Product"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "cover", // Ensures the image covers the entire box
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      pb={5}
                      alignContent={"center"}
                    >
                      <Box className={classes.productBarCodeBox}>
                        <Barcode value={product?.productBarcode ?? ""} />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      pb={5}
                      alignContent={"center"}
                    >
                      <Box className={classes.productBarCodeBox}>
                        <Box
                          sx={{
                            marginLeft: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              width: 50,
                              height: 50,
                              backgroundColor:
                                product?.productButtonColor ?? "",
                              marginLeft: 1,
                              border: "1px solid #d3d3d3",
                              borderRadius: "8px",
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>

    <Grid item lg={9} md={9} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
             {/*  <Grid container spacing={2}>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Active :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.productCanSell ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Variant :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.hasVariants ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Modifier Group :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.hasVariants ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>


              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Product View Online :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.productViewOnline ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Looping :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.productDetailsIsLooping ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid> */}


<Grid container spacing={2} >
   {cardsData.map((card, index) => (
    <Grid item xs={12} sm={6} md={2.4} onClick={() => setSelectedCard(card.title)}  sx={{ cursor: "pointer" }}>
      <Card className={classes.stepperCard} sx={{ minHeight: "150px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} pt={2}>
            <Grid container justifyContent="space-between" spacing={5} sx={{ borderBottom: 2, p: 2 }} className={classes.titleGrid}>
              <Grid item xs={12} pt={2} alignContent="center">
                <Typography variant="subtitle1">
                  <span className={classes.customerDetails}>{card.title} :</span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container justifyContent="center" alignItems="center" spacing={5} sx={{ px: 2 }} className={classes.titleGrid}>
              <Grid item xs={12} container justifyContent="center" alignItems="center" direction="column" textAlign="center">
               <Typography variant="subtitle1"  sx={{ fontSize: "25px", color:  card.title === "Modifier Group" && Array.isArray(card.value) && card.value.length > 0
        ? "success.main"
        : "error.main",
  }}
>
                {card.title === "Modifier Group"
              ? (Array.isArray(card.value) ? card.value.filter((selection: any) =>
          modifierGroupList.some(group => group.id === selection.modifierGroupId)
        ).length : 0)
                     : (card.value ? (
                    <CheckRoundedIcon color="success" sx={{ fontSize: "42px" }} />
                  ) : (
                    <ClearRoundedIcon color="error" sx={{ fontSize: "42px" }} />
                  ))
  }
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  ))}
</Grid>
          
</Grid>
          {/* <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={1} pb={5}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          {product?.productName}
                        </span>{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Name :
                        </span>{" "}
                        {product?.productName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Category :
                        </span>{" "}
                        {categoryMap.get(product?.productCategoryId) || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Brand :
                        </span>{" "}
                        {productBrandMap.get(product?.productBrandId) || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Tag :
                        </span>{" "}
                        {(product?.productTagIds || [])
                          .map((tagId) => productTagMap.get(tagId) || "")
                          .join(", ")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Conversion unit :
                        </span>{" "}
                        {product?.productConversionUnit
                          ?.map((unit) => {
                            const unitLabel = Object.keys(SizeOfLevelType).find(
                              (key) =>
                                SizeOfLevelType[
                                  key as keyof typeof SizeOfLevelType
                                ] === unit
                            );
                            return unitLabel;
                          })
                          .join(", ") || " "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Printers :
                        </span>{" "}
                        {(product?.productPrinterIds || [])
                          .map((tagId) => ProductPrinterMap.get(tagId) || "")
                          .join(", ")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Short Description :
                        </span>{" "}
                        {product?.productShortDescription}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid> */}


{selectedCard === "Variant" && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
   <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>New Variant</Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item>
              {/* <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Template Name .."
                sx={{ width: "100%" }}
                size="small"
              /> */}
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                className={classes.addButton}
               onClick={handleCreateOpenDialog}
              >
                Add Variant
              </Button>
            </Grid>

           
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                {/* <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Variant Name</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Price</strong>
                </TableCell>
                  <TableCell className={classes.tablheader}>
                  <strong>Order</strong>
                </TableCell>
                 <TableCell className={classes.tablheader}>
                  <strong>Active</strong>
                </TableCell>
                <TableCell className={classes.tablheader} sx={{textAlign: "right"}}>
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || coursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                coursings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IVariantPopUP, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell scope="row" className={classes.tablCell}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.productName}
                      </TableCell>
                     <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.productPrice}
                      </TableCell>
                       <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.orderNumber}
                          </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                                              {row.isActive ? "Active" : "Inactive"}
                                            </TableCell>
                      <TableCell scope="row" className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.editButtonList}
                              onClick={() => handleOpenDialog(row)}
                            >
                              <EditSharpIcon className={classes.editListIcon} />
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(row)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              {/* <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              /> */}
            </Grid>
          </Grid>
        </TableContainer>
        {openCreateVariantDialog && (
          <CreateVariantPopUp
            openModel={openCreateVariantDialog}
            handleCloseDialog={handleCreateCloseDialog}
            productId={String(ProductId)}
          />
        )}
         {selectedProduct && (
          <EditVariantPopUp
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedProduct}
          />
        )}
        {productToDelete && (
          <DeletePopup
            open={openDeleteProduct}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(productToDelete.id.toString());
            }}
            title="Delete Product"
            content={`Are you sure you want to delete "${productToDelete.productName}"?`}
          />
        )}
      </Grid>
    </Card>

            
          </Grid>

      )}  


      {selectedCard === 'Modifier Group' && (
          <><Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                    <Typography className={classes.cardTitle}>Modifier Group</Typography>
                  </Grid>
                  <Grid
                    item
                    lg={8}
                    md={8}
                    sm={8}
                    xs={8}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                        {/* <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <CiSearch className={classes.searchWidgetIcon} />
          </InputAdornment>
        ),
        classes: {
          root: classes.formControlList,
        },
      }}
      fullWidth
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      placeholder="Template Name .."
      sx={{ width: "100%" }}
      size="small"
    /> */}
                      </Grid>

                      <Grid item>
                        {/* {(!selectedModifierGroups || selectedModifierGroups.length === 0) ? ( */}
                        <Button
                          variant="contained"
                          className={classes.addButton}
                          onClick={() => {
                            setSelectedModifierGroupId(null);
                            setModifierGroupDetails(null);
                            setShowModifierGroupPopup(true);
                          } }
                        >
                          Add
                        </Button>

                        {/* ) : (
      <Button
        variant="contained"
        className={classes.addButton}
        onClick={() => setShowModifierGroupPopup(true)}
      >
        Edit
      </Button>
    )} */}
                      </Grid>


                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                          {/* <TableCell className={classes.tablheader}>
      <CustomCheckbox name="checkbox" />
    </TableCell> */}
                          <TableCell className={classes.tablheader}>
                            <strong>#</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong>Modifier Group Name</strong>
                          </TableCell>
                          {/* <TableCell className={classes.tablheader}>
     <strong> Modifiers</strong>
   </TableCell> */}
                          <TableCell className={classes.tablheader}>
                            <strong> Required</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong> Minimum</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong> Maximum</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong> Order</strong>
                          </TableCell>

                          <TableCell
                            className={classes.tablheader}
                            sx={{ textAlign: "right" }}
                          >
                            <strong>Actions</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {isError || selectedModifierGroups.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {isError ? "Error fetching data" : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                          selectedModifierGroups.map((savedGroup, idx) => {
                            // find full modifier group details from master list
                            const groupDetails = modifierGroupList.find(
                              (mg) => Number(mg.id) === Number(savedGroup.modifierGroupId)
                            );
                            //console.log("modifierGroupList", modifierGroupList);
                            if (!groupDetails) return null; // skip if no details found

                            return (
                              <TableRow key={savedGroup.modifierGroupId} className={classes.tableRowHover}>
                                <TableCell scope="row" className={classes.tablCell}>{idx + 1}</TableCell>
                                <TableCell scope="row" className={classes.tablCell}>{groupDetails.modifierGroupName}</TableCell>
                                {/* <TableCell  scope="row" className={classes.tablCell}>
                      {Array.isArray(groupDetails.modifiers) && groupDetails.modifiers.length > 0 ? (
                        <Table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                            <tr>
                              <th style={{ textAlign: "left", padding: "4px 8px" }}>Name</th>
                              <th style={{ textAlign: "left", padding: "4px 8px" }}>Overwrite</th>
                              <th style={{ textAlign: "left", padding: "4px 8px" }}>Price</th>
                            </tr>
                          </thead>
                          <tbody>
                        {(savedGroup.modifiers ?? []).map((mod, index) => {
          const modInfo = modifierList.find((m) => Number(m.id) === Number(mod.modifier_id));
          const name = modInfo ? modInfo.modifierName : `ID: ${mod.modifier_id}`;
                              return (
                                <tr key={index}>
                                  <td style={{ padding: "4px 8px" }}>{name}</td>
                                  <td style={{ padding: "4px 8px" }}>{mod.overwrite ? "Yes" : "No"}</td>
                                  <td style={{ padding: "4px 8px" }}>
                                    {mod.overwrite ? `$${(mod.overwrite_price ?? 0).toFixed(2)}` : "-"}
                                  </td>
                                </tr>
                            );
        })}
                          </tbody>
                        </Table>
                      ) : (
                        "No modifiers"
                      )}
                    </TableCell> */}
                                <TableCell scope="row" className={classes.tablCell}>
                                  {savedGroup.required ? "Yes" : "No"}
                                </TableCell>

                                <TableCell scope="row" className={classes.tablCell}>
                                  {savedGroup.minimum ?? "-"}
                                </TableCell>

                                <TableCell scope="row" className={classes.tablCell}>
                                  {savedGroup.maximum ?? "-"}
                                </TableCell>
                                <TableCell scope="row" className={classes.tablCell}>
                                  {savedGroup?.order != null ? savedGroup.order : '-'}
                                </TableCell>
                                <TableCell className={classes.tablCell}>
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{ display: "flex", justifyContent: "flex-end" }}
                                  >
                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        className={classes.editButtonList}
                                        onClick={() => handleEditModifierGroup(savedGroup)}
                                      >
                                        <VisibilitySharpIcon className={classes.editListIcon} />
                                      </Button>
                                    </Grid>

                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        className={classes.deleteButtonList}
                                        onClick={() => handleDeleteModifierGroup(savedGroup.modifierGroupId)}
                                      >
                                        <DeleteOutlineSharpIcon
                                          className={classes.deleteListIcon} />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </TableCell>
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                    {/* <TablePagination
      rowsPerPageOptions={[5, 10, 25]}
      component="div"
      count={coursings.length}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      // className={classes.tablePagination}
    /> */}
                    <Grid
                      spacing={5}
                      p={"18px"}
                      py={4}
                      justifyContent={"end"}
                      container
                      textAlign={"center"}
                      alignContent={"center"}
                      alignItems={"center"}
                    >
                      <Grid
                        sx={{
                          textAlign: "end",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                        {/* <Pagination
      count={coursings.length}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
    /> */}
                      </Grid>
                    </Grid>
                  </TableContainer>
                  {openCreateVariantDialog && (
                    <CreateVariantPopUp
                      openModel={openCreateVariantDialog}
                      handleCloseDialog={handleCreateCloseDialog}
                      productId={String(ProductId)} />
                  )}
                  {selectedProduct && (
                    <EditVariantPopUp
                      openModel={openDialog}
                      handleCloseDialog={handleCloseDialog}
                      data={selectedProduct} />
                  )}
                  {productToDelete && (
                    <DeletePopup
                      open={openDeleteProduct}
                      handleCloseDelete={handleCloseDeletePopup}
                      onConfirm={async () => {
                        await handleDelete(productToDelete.id.toString());
                      } }
                      title="Delete Product"
                      content={`Are you sure you want to delete "${productToDelete.productName}"?`} />
                  )}
                </Grid>
              </Card>


            </Grid>
            
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                      <Typography className={classes.cardTitle}>Linked Products</Typography>
                    </Grid>
                    <Grid
                      item
                      lg={8}
                      md={8}
                      sm={8}
                      xs={8}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                        
                        </Grid>

                        <Grid item>
                        
                          <Button
                            variant="contained"
                            className={classes.addButton}
                            onClick={() => {
                              // setSelectedModifierGroupId(null);
                              // setModifierGroupDetails(null);
                             setShowLinkedProductPopup(true);
                            } }
                          >
                            Add
                          </Button>

                       
                        </Grid>


                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid>
                    <TableContainer>
                      <Table className={classes.table}>
                        <TableHead className={classes.tableHeaderRow}>
                          <TableRow>
                        
                            <TableCell className={classes.tablheader}>
                              <strong>#</strong>
                            </TableCell>
                            <TableCell className={classes.tablheader}>
                              <strong>Product Name</strong>
                            </TableCell>
                           
                            
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {isError || linkedProducts.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                {isError ? "Error fetching data" : "No data available"}
                              </TableCell>
                            </TableRow>
                          ) : (
                            linkedProducts.map((savedGroup, idx) => {
                              // find full modifier group details from master list
                                  const groupDetails = products.find(
        (p) => Number(p.id) === Number(savedGroup) // savedGroup is the ID
      );
      if (!groupDetails) return null;

                              return (
                                <TableRow key={savedGroup.linkedProductId} className={classes.tableRowHover}>
                                  <TableCell scope="row" className={classes.tablCell}>{idx + 1}</TableCell>
                                  <TableCell scope="row" className={classes.tablCell}>{groupDetails.productName}</TableCell>
                                 
                                 
                                  <TableCell className={classes.tablCell}>
                                    <Grid
                                      container
                                      spacing={1}
                                      sx={{ display: "flex", justifyContent: "flex-end" }}
                                    >
                                      {/* <Grid item>
                                        <Button
                                          variant="contained"
                                          className={classes.editButtonList}
                                           onClick={() => handleEditModifierGroup(savedGroup)}
                                        >
                                          <VisibilitySharpIcon className={classes.editListIcon} />
                                        </Button>
                                      </Grid> */}

                                      <Grid item>
                                        <Button
                                          variant="contained"
                                          className={classes.deleteButtonList}
                                           onClick={() => handleDeleteLinkedProduct(savedGroup)}
                                        >
                                          <DeleteOutlineSharpIcon
                                            className={classes.deleteListIcon} />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          )}
                        </TableBody>
                      </Table>
                   
                      <Grid
                        spacing={5}
                        p={"18px"}
                        py={4}
                        justifyContent={"end"}
                        container
                        textAlign={"center"}
                        alignContent={"center"}
                        alignItems={"center"}
                      >
                        <Grid
                          sx={{
                            textAlign: "end",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                        
                        </Grid>
                      </Grid>
                    </TableContainer>
                    {openCreateVariantDialog && (
                      <CreateVariantPopUp
                        openModel={openCreateVariantDialog}
                        handleCloseDialog={handleCreateCloseDialog}
                        productId={String(ProductId)} />
                    )}
                    {selectedProduct && (
                      <EditVariantPopUp
                        openModel={openDialog}
                        handleCloseDialog={handleCloseDialog}
                        data={selectedProduct} />
                    )}
                    {productToDelete && (
                      <DeletePopup
                        open={openDeleteProduct}
                        handleCloseDelete={handleCloseDeletePopup}
                        onConfirm={async () => {
                          await handleDelete(productToDelete.id.toString());
                        } }
                        title="Delete Product"
                        content={`Are you sure you want to delete "${productToDelete.productName}"?`} />
                    )}
                  </Grid>
                </Card>


              </Grid></>

      )}  




          {product?.productDetailsIsLooping == true && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard} sx={{ minHeight: "250px" }}>
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography variant="subtitle1">
                          <span className={classes.customerDetails}>
                            Looping :
                          </span>{" "}
                          {product?.loopingDetails?.shortTableName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  {product?.productDetailsIsLooping && (
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Card className={classes.stepperCard}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={2}
                          sx={{ padding: 2 }}
                          className={classes.titleGrid}
                        >
                          {product?.loopingDetails?.tableColumns.map(
                            (column, index) => (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                pt={2}
                                alignContent={"center"}
                                key={index}
                                className={
                                  classes.productViewPageTableHeaderCell
                                }
                              >
                                <Typography>
                                  <span className={classes.customerDetails}>
                                    {column.name} :
                                  </span>{" "}
                                  {column.type === "boolean"
                                    ? column.value
                                      ? "True"
                                      : "False"
                                    : column.value}
                                </Typography>
                              </Grid>
                            )
                          )}
                        </Grid>
                      </Card>
                    </Grid>
                  )}
                </Grid>
              </Card>
            </Grid>
          )}
        </Grid>
      </Grid>


    <Dialog open={showModifierGroupPopup} onClose={() => setShowModifierGroupPopup(false)} maxWidth="md" fullWidth>
  <DialogTitle>Select Modifier Group</DialogTitle>
  <DialogContent >
  
  
  <FormControl fullWidth size="small" sx={{ mb: 2, mt: 2 }}>
<Autocomplete
  options={filteredModifierGroups}
  getOptionLabel={option => option.modifierGroupName ?? ''}
  value={
  modifierGroupList.find(group => Number(group.id) === selectedModifierGroupId) || null
}

  onChange={(event, newValue) => {
    if (newValue) {
      setSelectedModifierGroupId(Number(newValue.id));
      setModifierGroupDetails(newValue);
    } else {
      setSelectedModifierGroupId(null);
      setModifierGroupDetails(null);
    }
  }}

  renderInput={params => <TextField {...params} label="Select Modifier Group" size="small" />}
/>

</FormControl>

  
{modifierGroupDetails && (
  <>
<Grid container spacing={2} mt={1} mb={4}>
 <Grid item xs={6} md={3}>
  <TextField
    label="Minimum"
    type="number"
    size="small"
    fullWidth
    value={modifierGroupDetails.minimum ?? ''}
    onChange={(e) =>
      setModifierGroupDetails(prev =>
        prev
          ? {
              ...prev,
              minimum: e.target.value === '' ? 0 : parseInt(e.target.value, 10),
            }
          : prev
      )
    }
  />
</Grid>

<Grid item xs={6} md={3}>
  <TextField
    label="Maximum"
    type="number"
    size="small"
    fullWidth
    value={modifierGroupDetails.maximum ?? ''}
    onChange={(e) =>
      setModifierGroupDetails(prev =>
        prev
          ? {
              ...prev,
              maximum: e.target.value === '' ? 0 : parseInt(e.target.value, 10),
            }
          : prev
      )
    }
  />
</Grid>




      <Grid item xs={6} md={3}>
        <TextField
          label="Order No."
          type="number"
          size="small"
          fullWidth
          value={modifierGroupDetails.order ?? ''}
          onChange={(e) =>
            setModifierGroupDetails(prev => prev ? { ...prev, order: parseInt(e.target.value) || 0 } : prev)
          }
        />
      </Grid>

      <Grid item xs={6} md={3} display="flex" alignItems="center">
        <FormControlLabel
          control={
            <Switch
              checked={modifierGroupDetails.required ?? false}
              onChange={(e) =>
                setModifierGroupDetails(prev => prev ? { ...prev, required: e.target.checked } : prev)
              }
              color="primary"
            />
          }
          label="Required"
        />
      </Grid>
    </Grid>


    <Table className={classes.table} >
      <TableHead className={classes.tableHeaderRow}>
        <TableRow>
          <TableCell  className={classes.tablheader}> <strong>Modifier Name </strong></TableCell>
          <TableCell  className={classes.tablheader}> <strong>Overwrite</strong></TableCell>
          <TableCell  className={classes.tablheader}> <strong>Price</strong></TableCell>
        </TableRow>
      </TableHead>
     <TableBody>
    {(modifierGroupDetails.modifiers ?? []).map((mod, index) => {
      const modInfo = modifierList.find((m) => m.id === mod.modifier_id);
      const name = modInfo ? modInfo.modifierName : `ID: ${mod.modifier_id}`;

   const handleOverwriteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const updated = [...(modifierGroupDetails.modifiers ?? [])];
  updated[index] = { ...updated[index], overwrite: e.target.checked }; // Ensure immutability
  if (!e.target.checked) {
    updated[index].overwrite_price = 0;
  }
  setModifierGroupDetails({ ...modifierGroupDetails, modifiers: updated });
};

const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const updated = [...(modifierGroupDetails.modifiers ?? [])];
  updated[index] = {
    ...updated[index],
    overwrite_price: parseFloat(e.target.value) || 0,
  };
  setModifierGroupDetails({ ...modifierGroupDetails, modifiers: updated });
};

      return (
        <TableRow key={index}>
          <TableCell className={classes.tablCell}>{name}</TableCell>
          <TableCell className={classes.tablCell}>
            <CustomCheckbox
              checked={mod.overwrite || false}
              onChange={handleOverwriteChange}
              color="primary"
            />
          </TableCell>
          <TableCell className={classes.tablCell}>
           <TextField
  type="number"
  value={mod.overwrite ? mod.overwrite_price ?? '' : ''}
  onChange={handlePriceChange}
  inputProps={{ step: "0.01", min: "0" }}
  size="small"
  disabled={!mod.overwrite}
  sx={{
    minWidth: '80px',
    backgroundColor: mod.overwrite ? 'transparent' : 'transparent',
    visibility: mod.overwrite ? 'visible' : 'hidden', // still takes space
  }}
/>

          </TableCell>
        </TableRow>
      );
    })}
  </TableBody>
    </Table>

    
  </>
)}

  </DialogContent>
  <DialogActions>
   


<Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                      <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
     variant="outlined"
    className={classes.addButton}
    color="primary"
    onClick={() => setShowModifierGroupPopup(false)}
  >Cancel </Button>
                          <Box m={0.5}></Box>

                         <Button
    variant="contained"
    className={classes.addButton}
    color="primary"
    onClick={handleSaveModifierGroups}
  >
    Save
  </Button>

                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

</DialogActions>
</Dialog>



 <Dialog open={showLinkedProductPopup} onClose={() => setShowLinkedProductPopup(false)} maxWidth="md" fullWidth>
  <DialogTitle>Select Linked Products</DialogTitle>
  <DialogContent >
    <FormControl fullWidth size="small" sx={{ mb: 2, mt: 2 }}>
   <Autocomplete<IProduct>
      options={filteredProducts.filter(p => String(p.id) !== String(ProductId))}
    getOptionLabel={(option) => option.productName ?? ""}
   onChange={(event, newValue) => {
    console.log(ProductId, filteredProducts);
  if (newValue) {
    setLinkedProducts(prev => {
      const cleaned = prev.filter(p => p && typeof p === 'object');
      if (!cleaned.some(p => p.id === newValue.id)) {
        return [...cleaned, newValue];
      }
      return cleaned;
    });
  }
}}

    renderInput={(params) => <TextField {...params} label="Select Product" />}
  />
</FormControl>
  </DialogContent>
  <DialogActions>
   


<Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                      <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
     variant="outlined"
    className={classes.addButton}
    color="primary"
    onClick={() => setShowLinkedProductPopup(false)}
  >Cancel </Button>
                          <Box m={0.5}></Box>

                         <Button
    variant="contained"
    className={classes.addButton}
    color="primary"
    onClick={handleSaveLinkedProducts}
  >
    Save
  </Button>

                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

</DialogActions>
</Dialog>


    </Grid>








  );
};

export default Index;
